import { useEffect, useState } from "react";
import client from "../api/client";

const getVal = (x, ...keys) => {
  for (const k of keys)
    if (x?.[k] !== undefined && x?.[k] !== null) return x[k];
  return "";
};

const num = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

const styles = {
  page: { padding: 0, fontSize: 11 },
  card: {
    background: "#fff",
    borderRadius: 14,
    boxShadow: "0 2px 10px rgba(0,0,0,.08)",
    overflow: "hidden",
  },
  header: {
    background: "linear-gradient(90deg,#dc3545,#b02a37)",
    color: "#fff",
    padding: "8px 12px",
  },
  title: { fontSize: 13, fontWeight: 700 },
  sub: { fontSize: 10, opacity: 0.85 },
  body: { padding: 10 },
  tableWrap: {
    overflowX: "auto",
    border: "1px solid #e9ecef",
    borderRadius: 10,
  },
  table: { fontSize: 11, marginBottom: 0, minWidth: 600 },
  th: {
    fontSize: 10,
    padding: "7px 8px",
    color: "#fff",
  },
  td: { fontSize: 11, padding: "6px 8px", whiteSpace: "nowrap" },
};

export default function SupplierOutstandingPage() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const res = await client.get("/finance/supplier-outstanding");
    setRows(res.data || []);
  };

  const total = rows.reduce(
    (s, r) => s + num(getVal(r, "Balance", "balance")),
    0,
  );

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.header}>
          <div style={styles.title}>
            <i className="bi bi-truck me-2"></i>
            Supplier Outstanding / Payables
          </div>
          <div style={styles.sub}>Supplier-wise pending payable balances</div>
        </div>

        <div style={styles.body}>
          <div
            style={{
              fontSize: 10,
              color: "#6c757d",
              marginBottom: 6,
            }}
          >
            Total Payable: <strong>₹ {total.toFixed(2)} Cr</strong>
          </div>

          <div style={styles.tableWrap}>
            <table
              className="table table-bordered table-hover align-middle"
              style={styles.table}
            >
              <thead>
                <tr>
                  <th style={styles.th}>Account</th>
                  <th className="text-end" style={styles.th}>
                    Payable
                  </th>
                </tr>
              </thead>

              <tbody>
                {rows.length === 0 ? (
                  <tr>
                    <td
                      colSpan="2"
                      className="text-center text-muted"
                      style={{ ...styles.td, padding: 18 }}
                    >
                      No outstanding
                    </td>
                  </tr>
                ) : (
                  rows.map((r, i) => {
                    const balance = num(getVal(r, "Balance", "balance"));

                    return (
                      <tr key={i}>
                        <td style={styles.td}>
                          {getVal(r, "AccountName", "accountName")}
                        </td>

                        <td
                          className="text-end"
                          style={{
                            ...styles.td,
                            fontWeight: 700,
                            color: "#dc3545",
                          }}
                        >
                          {balance.toFixed(2)} Cr
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>

              <tfoot>
                <tr
                  style={{
                    background: "#f8f9fa",
                    fontWeight: 700,
                  }}
                >
                  <td className="text-end" style={styles.td}>
                    Total
                  </td>

                  <td
                    className="text-end"
                    style={{
                      ...styles.td,
                      color: "#dc3545",
                    }}
                  >
                    {total.toFixed(2)} Cr
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
